module.exports = __webpack_public_path__ + "static/fran-5d52e4258b1a63c42282fd0c6ad4898e.jpg";